import { render, staticRenderFns } from "./kut.vue?vue&type=template&id=04bc332e&scoped=true&"
import script from "./kut.vue?vue&type=script&lang=js&"
export * from "./kut.vue?vue&type=script&lang=js&"
import style0 from "./kut.vue?vue&type=style&index=0&id=04bc332e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bc332e",
  null
  
)

export default component.exports